module.exports = __webpack_public_path__ + "static/media/termopary6kz.6622205a.pdf";